import { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  title?: string;
  variant?: 'default' | 'bordered' | 'elevated' | 'brutalist';
}

export const Card = ({
  children,
  title,
  variant = 'default',
  className = '',
  ...props
}: CardProps) => {
  const variantClasses = {
    default: 'bg-white p-6 rounded-lg shadow-sm transition-all duration-300 hover:shadow-md',
    bordered: 'bg-white p-6 rounded-none border-2 border-gray-300 transition-all duration-300 hover:border-gray-400',
    elevated: 'bg-white p-6 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1',
    brutalist: 'bg-white p-8 border-4 border-rich_black-500 shadow-[8px_8px_0px_0px_rgba(2,5,18,1)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[12px_12px_0px_0px_rgba(2,5,18,1)] gpu-accelerated card-border-pulse',
  };

  return (
    <article
      className={`${variantClasses[variant]} ${className}`}
      {...props}
    >
      {title && (
        <h3 className={`mb-6 ${variant === 'brutalist' ? 'font-display text-2xl md:text-3xl font-bold uppercase tracking-wide border-b-4 border-indigo_dye-500 pb-3 inline-block transition-colors duration-300' : 'text-xl font-semibold mb-4'}`}>
          {title}
        </h3>
      )}
      {children}
    </article>
  );
}; 